export const Logo = (
  { size, primary, secondary }: {
    size: number
    primary: string
    secondary: string
  },
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 186 173'
    height={String(size)}
    width={String(size)}
  >
    <defs>
      <circle id='a' cx='0' cy='0' r='7' fill={primary} />
    </defs>
    <use x='35' y='9.2' href='#a' />
    <use x='54.3' y='9.2' href='#a' />
    <use x='73.7' y='9.2' href='#a' />
    <use x='131.6' y='9.2' href='#a' />
    <use x='150.9' y='9.2' href='#a' />
    <use x='15.7' y='28.6' href='#a' />
    <use x='35' y='28.6' href='#a' />
    <use x='54.3' y='28.6' href='#a' />
    <use x='73.7' y='28.6' href='#a' />
    <use x='93' y='28.6' href='#a' />
    <use x='150.9' y='28.6' href='#a' />
    <use x='170.3' y='28.6' href='#a' />
    <use x='15.7' y='48' href='#a' />
    <use x='35' y='48' href='#a' />
    <use x='73.7' y='48' href='#a' />
    <use x='93' y='48' href='#a' />
    <use x='150.9' y='48' href='#a' />
    <use x='170.3' y='48' href='#a' />
    <use x='15.7' y='67.5' href='#a' />
    <use x='35' y='67.5' href='#a' />
    <use x='73.7' y='67.5' href='#a' />
    <use x='93' y='67.5' href='#a' />
    <use x='150.9' y='67.5' href='#a' />
    <use x='170.3' y='67.5' href='#a' />
    <use x='15.7' y='86.9' href='#a' />
    <use x='35' y='86.9' href='#a' />
    <use x='73.7' y='86.9' href='#a' />
    <use x='93' y='86.9' href='#a' />
    <use x='150.9' y='86.9' href='#a' />
    <use x='170.3' y='86.9' href='#a' />
    <use x='15.7' y='106.3' href='#a' />
    <use x='35' y='106.3' href='#a' />
    <use x='73.7' y='106.3' href='#a' />
    <use x='93' y='106.3' href='#a' />
    <use x='150.9' y='106.3' href='#a' />
    <use x='170.3' y='106.3' href='#a' />
    <use x='15.7' y='125.7' href='#a' />
    <use x='35' y='125.7' href='#a' />
    <use x='73.7' y='125.7' href='#a' />
    <use x='93' y='125.7' href='#a' />
    <use x='150.9' y='125.7' href='#a' />
    <use x='170.3' y='125.7' href='#a' />
    <use x='15.7' y='145.2' href='#a' />
    <use x='35' y='145.2' href='#a' />
    <use x='54.3' y='145.2' href='#a' />
    <use x='73.7' y='145.2' href='#a' />
    <use x='93' y='145.2' href='#a' />
    <use x='150.9' y='145.2' href='#a' />
    <use x='170.3' y='145.2' href='#a' />
    <use x='35' y='164.6' href='#a' />
    <use x='54.3' y='164.6' href='#a' />
    <use x='73.7' y='164.6' href='#a' />
    <use x='93' y='164.6' href='#a' />
    <use x='170.3' y='164.6' href='#a' />
    <use x='54.3' y='9.2' href='#a' />
    <use x='73.7' y='9.2' href='#a' />
    <use x='131.6' y='9.2' href='#a' />
    <use x='150.9' y='9.2' href='#a' />
    <use x='150.9' y='9.2' href='#a' />
    <use x='35' y='28.6' href='#a' />
    <use x='54.3' y='28.6' href='#a' />
    <use x='73.7' y='28.6' href='#a' />
    <use x='93' y='28.6' href='#a' />
    <use x='150.9' y='28.6' href='#a' />
    <use x='170.3' y='28.6' href='#a' />
    <use x='15.7' y='48' href='#a' />
    <use x='35' y='48' href='#a' />
    <use x='73.7' y='48' href='#a' />
    <use x='93' y='48' href='#a' />
    <use x='150.9' y='48' href='#a' />
    <use x='170.3' y='48' href='#a' />
    <use x='15.7' y='67.5' href='#a' />
    <use x='35' y='67.5' href='#a' />
    <use x='73.7' y='67.5' href='#a' />
    <use x='93' y='67.5' href='#a' />
    <use x='150.9' y='67.5' href='#a' />
    <use x='170.3' y='67.5' href='#a' />
    <use x='15.7' y='86.9' href='#a' />
    <use x='35' y='86.9' href='#a' />
    <use x='73.7' y='86.9' href='#a' />
    <use x='93' y='86.9' href='#a' />
    <use x='150.9' y='86.9' href='#a' />
    <use x='170.3' y='86.9' href='#a' />
    <use x='170.3' y='86.9' href='#a' />
    <use x='15.7' y='106.3' href='#a' />
    <use x='35' y='106.3' href='#a' />
    <use x='73.7' y='106.3' href='#a' />
    <use x='93' y='106.3' href='#a' />
    <use x='150.9' y='106.3' href='#a' />
    <use x='170.3' y='106.3' href='#a' />
    <use x='15.7' y='125.7' href='#a' />
    <use x='35' y='125.7' href='#a' />
    <use x='73.7' y='125.7' href='#a' />
    <use x='93' y='125.7' href='#a' />
    <use x='150.9' y='125.7' href='#a' />
    <use x='170.3' y='125.7' href='#a' />
    <use x='15.7' y='145.2' href='#a' />
    <use x='35' y='145.2' href='#a' />
    <use x='54.3' y='145.2' href='#a' />
    <use x='73.7' y='145.2' href='#a' />
    <use x='93' y='145.2' href='#a' />
    <use x='150.9' y='145.2' href='#a' />
    <use x='170.3' y='145.2' href='#a' />
    <use x='170.3' y='145.2' href='#a' />
    <use x='170.3' y='145.2' href='#a' />
    <use x='35' y='164.6' href='#a' />
    <use x='54.3' y='164.6' href='#a' />
    <use x='73.7' y='164.6' href='#a' />
    <use x='93' y='164.6' href='#a' />
    <use x='170.3' y='164.6' href='#a' />
    <circle cx='15.7' cy='9.2' r='8.4' fill={secondary} />
  </svg>
)
